module.exports = __webpack_public_path__ + "img/certificate-blue.3e1fee46.svg";